<template>
  <div>
    <b-row>
      <!--WEB SERVICE-->
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="host" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.host_configuration')" :placeholderValue="$t('common.routing.host_configuration')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="port" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.port_configuration')" :placeholderValue="$t('common.routing.port_configuration')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <label for="ssl-active-select">
          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>
        </label>
        <select
            autocomplete="off"
          :aria-required='true'
          id="ssl-active-select"
          class="form-control"
          v-model="sslActive"
          :disabled="readonly">
          <option value="1"> {{ $t('common.routing.yes') }} </option>
          <option value="0" selected> {{ $t('common.routing.no') }} </option>
        </select>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!uriPathHasPipe">
        <form-write-group-label-input v-model="uri" :disabled="readonly" :maxLength="512"
          :inputLabel="$t('common.routing.uri_configuration')" :placeholderValue="$t('common.routing.uri_configuration')">
          <b-button v-if="!headerHttpHasPipe" slot="label-slot" variant="tertiary" class="config-buttons-title min-h-auto ml-3" @click="setHttpHeaders(0)">{{ labelHttpHeader }}</b-button>
          <b-form-checkbox
            slot="label-slot"
            v-if="isUriActive"
            v-model="uriActive"
            class="ml-5"
            :disabled="readonly"
            value="1"
            unchecked-value="0"
            >
            {{$t('common.routing.uriActivation')}}
          </b-form-checkbox>
        </form-write-group-label-input>
      </b-col>
      <b-col cols="12" class="mt-3" v-else>
        <span class="d-flex font-weight-bold mb-2">
          {{$t('common.routing.uriTitle')}}
          <b-button v-if="!headerHttpHasPipe" variant="tertiary" class="config-buttons-title min-h-auto ml-3" @click="setHttpHeaders(0)">{{ labelHttpHeader }}</b-button>
        </span>
        <template v-for="(path, index) in uriPathArray">
            <b-row class="form-group" :key="'uri-path-' + index">
                <b-col sm="6">
                  <form-write-group-label-input
                    v-model="path.access"
                    @input="changeUri"
                    :disabled="readonly"
                    :maxLength="512"
                    :inputLabel="selectPathUriLabel(path, index)"
                    :placeholderValue="$t('common.routing.uri')"
                  >
                    <b-form-checkbox
                      slot="label-slot"
                      v-if="path.active && path.active !== '-1'"
                      @change="changeUriActive"
                      v-model="path.active"
                      class="ml-3"
                      :disabled="readonly"
                      value="1"
                      unchecked-value="0"
                    >
                      {{$t('common.routing.uriActivation')}}
                    </b-form-checkbox>
                    <b-button v-if="headerHttpHasPipe" slot="label-slot" variant="tertiary" class="config-buttons-title min-h-auto ml-3" @click="setHttpHeaders(index)">{{ labelHttpHeader }}</b-button>
                  </form-write-group-label-input>
                </b-col>
              </b-row>
          </template>
      </b-col>
    </b-row>

    <form-accordion title="Authentification" :isTitleUpperCase="false" v-if="this.authSystem">
      <b-form-radio-group v-model="selectedAuthSystem" :disabled="readonly">
        <b-form-radio name="authType-radio" value="OAUTH2">Oauth2</b-form-radio>
        <b-form-radio name="authType-radio" value="APIKey">API Key</b-form-radio>
        <b-form-radio name="authType-radio" value="None">None</b-form-radio>
      </b-form-radio-group>
      <div v-if="isSelectedAuthSystemOAUTH2">
        <b-row>
          <b-col sm="6">
            <b-row>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input
                  v-model="Login2"
                  isMandatory
                  :disabled="readonly"
                  :inputLabel="$t('common.routing.login')"
                  :placeholderValue="$t('common.routing.login')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input
                  v-model="Password2"
                  :inputLabel="$t('common.routing.password')"
                  :placeholderValue="$t('common.routing.password')"
                  :inputType="passwordFieldType"
                  :disabled="readonly"
                  :inputIcon= "isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash'"
                  autocomplete="off"
                  @icon-click="toggleVisibility"
                  >
                </form-write-group-label-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input
              v-model="Host2"
              isMandatory
              :disabled="readonly"
              input-aria-label="Host OAuth2"
              :inputLabel="$t('common.routing.host')"
              :placeholderValue="$t('common.routing.host')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="Port2" isMandatory :disabled="readonly" input-aria-label="Port OAuth2"
              :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <label for="ssl-active-select-oauth2">
              {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>
            </label>
            <select autocomplete="off" input-aria-label="SSLMode OAuth2" class="form-control" v-model="SSLMode2" :disabled="readonly" id="ssl-active-select-oauth2" :aria-required=true >
              <option value="1"> {{ $t('common.routing.yes') }} </option>
              <option value="0" selected> {{ $t('common.routing.no') }} </option>
            </select>
          </b-col>
          <b-col cols="6" v-if="uriPathArray2 && uriPathArray2.length > 0" class="mt-3">
            <b-form-group :label="$t('common.routing.uriTitle')" label-class="font-weight-bold"></b-form-group>
          </b-col>
          <b-col sm="6" class="form-group" v-if="!uri2PathHasPipe">
            <form-write-group-label-input v-model="URI2" :disabled="readonly" :maxLength="512"
              :inputLabel="$t('common.routing.uri')" :placeholderValue="$t('common.routing.uri')">
              <b-button v-if="!headerHttp2HasPipe" slot="label-slot" variant="tertiary" class="config-buttons-title min-h-auto ml-3" @click="setHttpHeaders2(0)">{{ labelHttpHeader }}</b-button>
              <b-form-checkbox
                slot="label-slot"
                v-if="isUri2Active"
                v-model="URIActive2"
                class="ml-5"
                :disabled="readonly"
                value="1"
                unchecked-value="0"
                >
                {{$t('common.routing.uriActivation')}}
              </b-form-checkbox>
            </form-write-group-label-input>
          </b-col>
          <template v-for="(path, index) in uriPathArray2" v-else>
            <fieldset :key="'fieldset-web-config-' + index">
              <legend>
                {{ selectPathUriLabel(path, index) }}
                <b-button v-if="headerHttp2HasPipe" slot="label-slot" variant="tertiary" class="config-buttons-title min-h-auto ml-3" @click="setHttpHeaders2(index)">{{ labelHttpHeader }}</b-button>
                <b-form-checkbox
                  slot="label-slot"
                  v-if="path.active && path.active !== '-1'"
                  @change="changeUri2Active"
                  v-model="path.active"
                  class="ml-5"
                  :disabled="readonly"
                  value="1"
                  unchecked-value="0"
                >
                  {{$t('common.routing.uriActivation')}}
                </b-form-checkbox>
              </legend>
            </fieldset>
            <b-col sm="12" class="form-group" :key="path + '-' + index">
              <b-row>
                  <b-col sm="6">
                    <form-write-group-label-input
                      v-model="path.access"
                      @input="changeUri2"
                      :disabled="readonly"
                      :maxLength="512"
                      :inputLabel="selectPathUriLabel(path, index)"
                      :placeholderValue="$t('common.routing.uri')"
                    >
                      <b-form-checkbox
                        slot="label-slot"
                        v-if="path.active && path.active !== '-1'"
                        @change="changeUri2Active"
                        v-model="path.active"
                        class="ml-5"
                        :disabled="readonly"
                        value="1"
                        unchecked-value="0"
                      >
                        {{$t('common.routing.uriActivation')}}
                      </b-form-checkbox>
                    </form-write-group-label-input>
                  </b-col>
                </b-row>
            </b-col>
          </template>
        </b-row>
      </div>
      <b-row  v-if="isSelectedAuthSystemAPIKey">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="login" isMandatory :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.ApiKey')" :placeholderValue="$t('common.routing.ApiKey')">
            </form-write-group-label-input>
          </b-col>
        </b-row>

    </form-accordion>
  </div>
</template>
<script>

// import CertificateFormGlobal from '@/pages/routing/global/CertificateFormGlobal.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
// import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
// import PrivateKeysFormGlobal from '@/pages/routing/global/PrivateKeysFormGlobal.vue'

import _ from 'lodash'

export default {
  name: 'WebServiceConfigurationForm',
  components: {
    // 'certificate-form-global': CertificateFormGlobal,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput
    // 'level-control-form' : LevelControlForm,
    // 'private-keys-form-global': PrivateKeysFormGlobal
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    prefilledURI: {
      type: String,
      default: ''
    },
    placementWebService: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  data () {
    return {
      passwordFieldType: 'password',
      authSystem: "None",
      uriPathArray: [],
      uriPathArray2: [],
      httpHeaderArray: [],
      httpHeaderArray2: [],
      httpkeyList: [
        '<business-key-1>',
        '<business-key-2>',
        '<product-id>',
        '<format>',
        '<mode>',
        '<flow-type>',
        '<correlation_id32>',
        'Basic <client_credentials>',
        'Bearer <acces_token>',
        '<request_id>',
        '<correlation_id>'
      ]
    }
  },
  computed:{
    isPasswordFieldHidden () {
      return this.passwordFieldType === 'password'
    },
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    name: {
      get () {
        return this.inputValue.name
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.name = val
        this.inputValue = tmp
      }
    },
    host: {
      get () {
        return this.inputValue.host
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.host = val
        this.inputValue = tmp
      }
    },
    port: {
      get () {
        return this.inputValue.port
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.port = val
        this.inputValue = tmp
      }
    },
    uri: {
      get () {
        return this.inputValue.uri
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.uri = val
        this.inputValue = tmp
      }
    },
    uriActive: {
      get () {
        return this.inputValue.uriActive
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.uriActive = val
        this.inputValue = tmp
      }
    },
    uriLabel: {
      get () {
        return this.inputValue.uriLabel
      }
    },
    sslActive: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.sslActive
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.sslActive = val
        this.inputValue = tmp
      }
    },
    controlConfig:{
      get () {
        return this.inputValue.controlConfig
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.controlConfig = val
        this.inputValue = tmp
      }
    },
    certificateConfig:{
      get () {
        return this.inputValue.certificateConfig
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.certificateConfig = val
        this.inputValue = tmp
      }
    },
    privateKeysConfig:{
      get () {
        return this.inputValue.privateKeysConfig
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.privateKeysConfig = val
        this.inputValue = tmp
      }
    },
    login: {
      get () {
        return this.inputValue.login
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.login = val
        this.inputValue = tmp
      }
    },
    loginStorage: {
      get () {
        let storageMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return storageMatch && storageMatch.length > 1 ? storageMatch[1] : ''
      }
    },
    loginFile: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 3 ? envMatch[3] : ''
      }
    },
    loginFileType: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 2 ? envMatch[2] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    loginYAML: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 5 ? envMatch[5] : ''
      }
    },
    loginYAMLType: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 4 ? envMatch[4] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    password: {
      get () {
        return this.inputValue.password
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.password = val
        this.inputValue = tmp
      }
    },
    headerHttp: {
      get () {
        return this.inputValue.HeaderHttp
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.HeaderHttp = val
        this.inputValue = tmp
      }
    },
    headerHttp2: {
      get () {
        return this.inputValue.HeaderHttp2
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.HeaderHttp2 = val
        this.inputValue = tmp
      }
    },
    Host2: {
      get () {
        return this.inputValue.Host2
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.Host2 = val
        this.inputValue = tmp
      }
    },//
    IdWebService2: {
      get () {
        return this.inputValue.IdWebService2
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.IdWebService2 = val
        this.inputValue = tmp
      }
    },
    SSLMode2: {
      get () {
        return this.inputValue.SSLMode2
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.SSLMode2 = val
        this.inputValue = tmp
      }
    },
    Port2: {
      get () {
        return this.inputValue.Port2
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.Port2 = val
        this.inputValue = tmp
      }
    },
    URI2: {
      get () {
        return this.inputValue.URI2
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.URI2 = val
        this.inputValue = tmp
      }
    },
    Login2: {
      get () {
        return this.inputValue.Login2
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.Login2 = val
        this.inputValue = tmp
      }
    },
    Password2: {
      get () {
        return this.inputValue.Password2
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.Password2 = val
        this.inputValue = tmp
      }
    },
    URIActive2: {
      get () {
        return this.inputValue.URIActive2
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.URIActive2 = val
        this.inputValue = tmp
      }
    },
    URILabel2: {
      get () {
        return this.inputValue.URILabel2
      },
      set (val) {
        let tmp = _.cloneDeep(this.inputValue)
        tmp.URILabel2 = val
        this.inputValue = tmp
      }
    },
    passwordStorage: {
      get () {
        let storageMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return storageMatch && storageMatch.length > 1 ? storageMatch[1] : ''
      }
    },
    passwordFile: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 3 ? envMatch[3] : ''
      }
    },
    passwordFileType: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 2 ? envMatch[2] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    passwordYAML: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 5 ? envMatch[5] : ''
      }
    },
    passwordYAMLType: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 4 ? envMatch[4] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    selectedAuthSystem: {
      get() {
        return this.authSystem
      },

      set(value) {
        this.authSystem = value
        if (value === "OAUTH2") {
          this.login = 0
          //TODO supprimer api key
        }
        if (value === "None") {
          this.login = -1
          //TODO supprimer les autre
        }
        if (value === "APIKey") {
          if (this.login == -1 || this.login == 0) {
            this.login = ""
          }
        }
      }
    },
    isSelectedAuthSystemAPIKey() {
      return this.selectedAuthSystem === "APIKey"
    },
    isSelectedAuthSystemOAUTH2() {
      return this.selectedAuthSystem === "OAUTH2"
    },
    uriPathHasPipe () {
      return this.uri.includes('|')
    },
    uri2PathHasPipe () {
      if (this.URI2 === undefined) {
        return false
      }
      return this.URI2.includes('|')
    },
    headerHttpHasPipe () {
      return this.headerHttp?.includes('|')
    },
    headerHttp2HasPipe () {
      return this.headerHttp2?.includes('|')
    },
    isUriActive () {
      return this.uriActive && this.uriActive !== '-1'
    },
    isUri2Active () {
      return this.URIActive2 && this.URIActive2 !== '-1'
    },
    labelHttpHeader () {
      return this.readonly ? this.$i18n.t('common.routing.header_http.header_http_title') : this.$i18n.t('common.routing.header_http.header_http_set')
    }
  },
  created () {
    if (this.mode === 'create') {
      if (this.prefilledURI !== undefined || this.prefilledURI === '') {
        this.inputValue.uri = this.prefilledURI
      }
      this.inputValue.sslActive = "0"
    }
    let that = this
    this.$bus.$on('config-set-http-headers', e => {
      if (e.type === 1) {
        that.httpHeaderArray[e.index] = _.cloneDeep(e.HeaderHttp)
        that.changeHttpHeaderValue()
      } else if (e.type === 2) {
        that.httpHeaderArray2 = _.cloneDeep(e.HeaderHttp)
        that.changeHttpHeaderValue2()
      }
    })
    this.httpHeaderArray = this.inputValue.HeaderHttp.split('|').map(config =>
      config.split(';').map(header =>
        ({
          key: header.split('=')[0],
          type: that.httpkeyList.includes(header.split('=')[1]) ? header.split('=')[1] : '',
          value: header.split('=')[1] ? header.split('=')[1]
            .replaceAll('#PV#', ';')
            .replaceAll('#EQ#', '=') : ''
        })
      )
    )
    this.httpHeaderArray2 = this.inputValue.HeaderHttp2.split('|').map(config =>
      config.split(';').map(header =>
        ({
          key: header.split('=')[0],
          type: that.httpkeyList.includes(header.split('=')[1]) ? header.split('=')[1] : '',
          value: header.split('=')[1] ? header.split('=')[1]
            .replaceAll('#PV#', ';')
            .replaceAll('#EQ#', '=') : ''
        })
      )
    )
    if (this.uri.length > 0 && this.uriPathHasPipe) {
      let accessArray = this.uri.split('|')
      let activeArray = this.uriActive.split('|')
      let labelArray = this.uriLabel.split('|')
      this.uriPathArray = accessArray.map((_, i) => ({
        access: accessArray.length > i ? accessArray[i] : undefined,
        active: activeArray.length > i ? activeArray[i] : undefined,
        label: labelArray.length > i ? labelArray[i] : undefined,
      }))

    }
    if (this.URI2 && this.URI2.length > 0 && this.uri2PathHasPipe) {
      let accessArray = this.URI2.split('|')
      let activeArray = this.URIActive2.split('|')
      let labelArray = this.URILabel2.split('|')
      this.uriPathArray2 = accessArray.map((_, i) => ({
        access: accessArray.length > i ? accessArray[i] : undefined,
        active: activeArray.length > i ? activeArray[i] : undefined,
        label: labelArray.length > i ? labelArray[i] : undefined,
      }))
    }
  },
  mounted () {
    if (/*this.value.IdWebService2*/ this.login && this.login == 0) {
      this.authSystem = "OAUTH2"
    } else if (this.login && this.login == -1) {
      this.authSystem = "None"
    } else if (this.login && this.password !=undefined) {
      this.authSystem = "APIKey"
    }
    else {
      this.authSystem = null
    }
  },
  methods: {
    toggleVisibility () {
      if (this.passwordFieldType === 'password' && this.readonly === false) {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    changeUri () {
      this.uri = this.uriPathArray.map(elem => elem.access).join('|')
    },
    changeUri2(){
      this.URI2 = this.uriPathArray2.map(elem => elem.access).join('|')
    },
    changeUriActive () {
      this.uriActive = this.uriPathArray.map(elem => elem.active).join('|')
    },
    changeUri2Active () {
      this.URIActive2 = this.uriPathArray2.map(elem => elem.active).join('|')
    },
    changeHttpHeaderValue () {
      this.headerHttp = this.httpHeaderArray.map(elem => elem.map(subElem => subElem.key + '=' + subElem.value.replace(/;/g, '#PV#').replace(/=/g, '#EQ#')).join(';')).join('|')
    },
    changeHttpHeaderValue2 () {
      this.headerHttp2 = this.httpHeaderArray2.map(elem => elem.key + '=' + elem.value.replace(/;/g, '#PV#').replace(/=/g, '#EQ#')).join(';')
    },
    setHttpHeaders (index) {
      this.$bus.$emit('popup-set-http-headers', { index: index, HeaderHttp: _.cloneDeep(this.httpHeaderArray[index]), type: 1, readonly: this.readonly })
    },
    setHttpHeaders2 (index) {
      this.$bus.$emit('popup-set-http-headers', { index: 0, HeaderHttp: _.cloneDeep(this.httpHeaderArray2[index]), type: 2, readonly: this.readonly })
    },
    selectPathUriLabel (path, index) {
      if (!path.label || this.$i18n.t('common.routing.uriLabel.' + path.label) === 'common.routing.uriLabel.' + path.label) {
        return this.$i18n.t('common.routing.uri') + ' ' + (index + 1)
      }
      return this.$i18n.t('common.routing.uriLabel.' + path.label)
    }
  }
}

</script>
